import React from "react";

import { Panel } from "cortex/ui/src/view/layout";

import DevicesMap from "./component/DevicesMap";
import { Device } from "./model";

interface DevicesLocationMapProps {
  devices: ReadonlyArray<Device>;
}

function DevicesLocationMap({ devices }: DevicesLocationMapProps) {
  return (
    <Panel title="Device Location">
      <DevicesMap devices={devices} maxZoom={13} minZoom={7} />
    </Panel>
  );
}

export { DevicesLocationMap };
export default { DevicesLocationMap };
